import React,{ useState,useRef} from "react";
import styled from "styled-components";
import {showAlert} from "../../../globals/Message";
import { Row, Container } from 'react-bootstrap';
import Button from "../../../globals/Button";
import FormErrorMessage from "../../../globals/FormErrorMessage";
import {Formulario} from "../../../globals/dhtmlx/Form";
import "../reset.css"
import ReCAPTCHA from 'react-google-recaptcha';
import { apiCall } from "../../../../helpers/ApiCalls";
import { useHistory } from "react-router-dom";

const recaptcha_key = process.env.REACT_APP_RECAPTCHA;

const Wrapper = styled(Container)`
  display:grid;
  justify-content:center;
  align-items:center;
`;
const HeaderContianer = styled(Row)`
  display:grid;
  margin:0;
  padding:32px 0 16px ;
  justify-content:center;
  align-items:center;
`;
const H1 = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 32px  
`;
const BodyContianer = styled(Row)`
  display:grid;
  margin:0;
  padding:16px 24px;
  justify-content:center;
  align-items:center;
  max-width:360px;
  background:#F0F0F0;
  border: 1px solid #EDEDED;
  border-radius: 5px
`;
const MessageContianer = styled(Row)`
  display:grid;
  margin:16px 0;
  padding:16px 24px;
  justify-content:center;
  align-items:center;
  max-width:360px;
  background-color: #FFEBE9;
  border: 1px solid #FFC1C0;
  border-radius: 5px
`;
const CaptchaContianer = styled.div`
  display:flex;
  justify-content:center;
  margin-top:-16px;
  margin-bottom:16px;
`
function ResetPassword (){
  let history = useHistory();

  const [input, setInput] = useState({});
  const [valid, setValid] = useState(false);
  const [captchaValido, setCaptchaValido] = useState(process.env.REACT_APP_ENTORNO ==='Dev'?true:false);
  const captcha = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
 
  async function enviarLink(){
    setButtonLoading(true);
    if(captchaValido && valid && Object.keys(input).length >0){
      //hacemos la llamada a la API de
      await apiCall('POST','reset_password/send_link',input).then((res)=>{
        if(res.success && res.code === 200){
          showAlert("Se a enviado un correo con el Link para continuar con el proceso de recuperar tu contraseña.")
          history.push('/');
          return true;
         
        }
        setMessage("Ocurrio un error por favor intenta más tarde");
        setShowMessage(true);
        setButtonLoading(false);

        return true;
      });
      
    }else{
      if(!captchaValido){
        setMessage("Por favor valida tu identidad");
        setShowMessage(true);
      }
      setButtonLoading(false);
    }
    
  }
  function changeCaptcha (){
    if(captcha.current.getValue()){
      setCaptchaValido(true);
    }
    else{
      setCaptchaValido(false);

    }
  }
  function toggleInput(value){
    setInput(value);
  }

  const rows = [
    {
      id: "email",
      type: "input",
      label:"Email:",
      placeholder: "Ingresa tu email",
      preMessage: "",
      errorMessage: "Ingresa tu email",
      successMessage: "Email valido",
      validation: "email",
      required: true,
      css:"fondo-transparente",
    }  
  ];
  return (
    <Wrapper id="wrapper_contianer">
      <HeaderContianer id="header_container">
        <div style={{display:'flex',justifyContent:'center',alignItems:'center', margin:'0 24px 8px 0'}}>
          <img src="../gp.png" alt="_logo"></img>
        </div>
        <H1>Recuperar Contraseña</H1>
      </HeaderContianer>
      <BodyContianer>
        <span style={{textAlign:'leftjustify'}}>Ingresa el email con el que creaste tu cuenta, te inviaremos un link para actualizar tu contraseña.</span>
        <Formulario
          rows={rows}
          padding = {0}
          width = {'100%'}
          toggleInputs = {toggleInput}
          toggleValid = {setValid}
          toogleMessage = {()=>{}}
          loading = {buttonLoading}
          css={"fondo-transparente"}
        />
        <CaptchaContianer id="google_recaptcha">
          { process.env.REACT_APP_ENTORNO ==='Dccev'?(<></>):(<ReCAPTCHA
            ref={captcha}
            sitekey={recaptcha_key}
            onChange={changeCaptcha}
          />)}
        </CaptchaContianer>
        <Button width={'60%'} flat = {true} onClick={enviarLink} loading={buttonLoading}>Enviar Link</Button>
      </BodyContianer>
      <FormErrorMessage
          showMessage={showMessage}
          message={message}
          toggleMessage = {setShowMessage}
          width={'360px'}
        />
    </Wrapper>
  );
}
export default ResetPassword;